<style>

/* .no-contact{
  
} */

.img{
  width: 61px;
  height: 61px;
  border-radius: 61px;
}
.img-border{
  border: 2px white solid;
}

.has-contact{
  display: grid;
  grid-template-columns: 63px auto;
  margin-top: 10px;
  border: 1px white solid;
  border-radius: 10px;
  padding: 5px 3px 0 3px;
}
.image{
  grid-column: 1;
}
.text{
  grid-column: 2;
  margin-left: 10px;
  padding-top: 20px;
}
.margin{
  margin: 20px;
}
.contact-margin{
  margin: 16px;
}
</style>

<Header back="{true}" on:back="{ () => { pop() } }">Message</Header>
<div class="has-header"></div>

<div class="no-contact">
  
  <div class="margin">
    {#each friends as item}
      {#if !item.hasContacted}
      <span on:click="{ () => push('/friend-profile/'+item.uid) }"> <img src="{item.i}" alt="" class="img img-border"> </span>
      {/if}
    {/each}
  </div>
  
  {#each friends as item}
    {#if item.hasContacted}
    <div class="has-contact contact-margin" on:click="{ () => push('/message/'+item.uid) }">
      <div class="image"> <img src="{item.i}" alt="" class="img"> </div>
      <div class="text">{item.name}</div>
    </div>
    {/if}
  {/each}
  
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";

// uid = obfuscated_id
let friends = [
  {uid: "0000", name: "", hasContacted: false, i: "/i/p/0000.jpg"},
  {uid: "0001", name: "", hasContacted: false, i: "/i/p/0001.jpg"},
  {uid: "0002", name: "", hasContacted: false, i: "/i/p/0002.jpg"},
  {uid: "0003", name: "", hasContacted: false, i: "/i/p/0003.jpg"},
  {uid: "0004", name: "James Smith", hasContacted: true, i: "/i/p/0004.jpg"},
  {uid: "0006", name: "Rose Alibaster", hasContacted: true, i: "/i/p/0006.jpg"},
  {uid: "0005", name: "Lena Williamson", hasContacted: true, i: "/i/p/0005.jpg"},
];

</script>